import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Editor } from '@tinymce/tinymce-react'

import { DateTimePicker } from '@material-ui/pickers'

import moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/en-gb'

import getString, { target } from '../config/strings'

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
  },
})

const removeEnvelopingParagraph = (text) => {
  if (text.match(/^<p[^>]*>.*<\/p>$/)) {
    const shortenedText = text.substring(text.indexOf('>') + 1, text.lastIndexOf('<'))
    if ( ! shortenedText.match(/^.*?<\/p>/) ) return shortenedText
  }
  return text
}

class TariffsDialog extends PureComponent {

  constructor (props, context, updater) {
    super(props, context, updater)
    this.state = {
      actRecord: props.record,
      name: {
        error: false,
        message: ''
      },
      description: {
        error: true,
        message: '',
        initialValue: ''
      }
    }
    this.state.description.initialValue = props.record.description
  }

  changeField (fieldName, value) {
    let newRecord = Object.assign({}, this.state.actRecord)
    value = value.replace(/^\s+/, '')

    if (fieldName === 'name') {
      newRecord[fieldName] = value
      if (value === '') {
        this.setState({name: {error: true, message: getString('TARIFF_NAME_EMPTY')}, actRecord: newRecord})
      } else {
        this.setState({name: {error: false, message: ''}, actRecord: newRecord})
      }
    }

    if (fieldName === 'description') {
      const cleanedValue = removeEnvelopingParagraph(value || '')
      newRecord[fieldName] = value
      if (cleanedValue === '') {
        this.setState({
          description: {error: true, message: getString('TARIFF_DESCRIPTION_EMPTY')},
          actRecord: newRecord
        })
      } else {
        this.setState({
          description: {error: false, message: ''},
          actRecord: newRecord
        })
      }
    }
  }

  handleDateChange = (date) => {
    let newRecord = Object.assign({}, this.state.actRecord)
    newRecord['visible_from'] = date
    this.setState({actRecord: newRecord})
  }

  handleSave (event) {
    event.preventDefault()
    let newRecord = Object.assign({}, this.state.actRecord)
    newRecord.description = removeEnvelopingParagraph(newRecord.description || '')
    if (newRecord.name === '') {
      this.setState({name: {error: true, message: getString('TARIFF_NAME_EMPTY')}})
      return
    }
    if (newRecord.description === '') {
      this.setState({description: {error: true, message: getString('TARIFF_DESCRIPTION_EMPTY')}})
      return
    }
    this.props.saveFunc(newRecord)
  }

  render () {
    let classes = this.props.classes

    const momentLocaleString = target.choosenLanguage === 'en' ? 'en-gb' : target.choosenLanguage
    let myMoment = moment()
    myMoment.locale(momentLocaleString)

    return (<div>
      <Dialog
        open={true}
        aria-labelledby="form-dialog-title"
        maxWidth={false}
        disableEnforceFocus={true}
      >
        <form onSubmit={(event) => {this.handleSave(event)}}>
          <DialogTitle
            id="form-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="normal"
              id="tarif_name"
              label={getString('TARIFF_NAME')}
              required={true}
              type="text"
              error={this.state.name.error}
              helperText={this.state.name.message}
              onChange={(event) => {this.changeField('name', event.target.value)}}
              value={this.state.actRecord.name}
              fullWidth
            />
            <div className="picker">
              <DateTimePicker
                id='visible_from'
                ampm={false}
                fullWidth={true}
                allowKeyboardControl={true}
                format={myMoment.localeData().longDateFormat('L') + ' ' + myMoment.localeData().longDateFormat('LT')}
                margin="normal"
                label={getString('TARIFF_VISIBLE_FROM')}
                helperText={getString('TARIFF_VISIBLE_FROM_HELP')}
                okLabel={getString('OK')}
                cancelLabel={getString('CANCEL')}
                autoOk={false}
                value={this.state.actRecord.visible_from}
                onChange={this.handleDateChange}
              />
            </div>
            <FormControl className={classes.formControl}
                         error={this.state.description.error}
                         aria-describedby="description-helper-text">
              <InputLabel htmlFor="description-helper">{getString('TARIFF_DESCRIPTION')}</InputLabel>
              <Editor
                initialValue={this.state.description.initialValue}
                init={{
                  plugins: 'paste hr lists preview',
                  branding: false,
                  menubar: false,
                  resize: 'both',
                  theme: 'modern',
                  min_height: 240,
                  paste_data_images: false,
                  paste_word_valid_elements: 'b,strong,i,em,p,ul,li,ol,br',
                  paste_preprocess: function (plugin, args) {
                    args.content = args.content.replace(/<\/?(div|h1|h2|h3|h4|h5|span|font)[^>]*>/gi, '')
                  },
                  block_formats: 'Absatz=p',
                  toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist hr | outdent indent | preview',
                  content_css: 'stylesheets/tariffs_content.css',
                  entity_encoding: 'raw'
                }}
                onEditorChange={(text, editor) => {this.changeField('description', text)}}
              />
              <FormHelperText id="description-helper-text">{this.state.description.message}</FormHelperText>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.closeFunc} color="secondary">
              {getString('CANCEL')}
            </Button>
            <Button type="submit" variant="contained" size="small" color="primary">
              {this.props.action}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
  }
}

TariffsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  saveFunc: PropTypes.func.isRequired,
  closeFunc: PropTypes.func.isRequired
}

export default withStyles(styles)(TariffsDialog)
